import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import DealerLocatorPage from './pages/DealerLocatorPage';
import ProductsPage from './pages/ProductsPage';
import GalleryPage from './pages/GalleryPage';
import NewsPage from './pages/NewsPage';
import TestimonialsPage from './pages/TestimonialsPage';
import ServiceCentersPage from './pages/ServiceCentersPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CategoryPage from './pages/CategoryPage';
import EmailPage from './pages/EmailPage';
import CallExpertPage from './pages/CallExpertPage';
import EnquiryPage from './pages/EnquiryPage';
import ApplyPage from './pages/ApplyPage';
import MusicVideoPage from './pages/MusicVideoPage';
import RequestQuotePage from './pages/RequestQuotePage';
import LoginPage from './pages/LoginPage';
import OffersPage from './pages/OffersPage';
import SubsidyPage from './pages/SubsidyPage';
import MachineryLoanPage from './pages/MachineryLoanPage';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function TitleManager() {
  useEffect(() => {
    document.title = 'Kisaanmaan';
  }, []);

  return null;
}

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <div className="App">
        <TitleManager />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/email" element={<EmailPage />} />
          <Route path="/dealer-locator" element={<DealerLocatorPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/category/:slug" element={<CategoryPage />} />
          <Route path="/product/:slug" element={<ProductDetailPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/services/subsidy" element={<SubsidyPage />} />
          <Route path="/services/loan" element={<MachineryLoanPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/service" element={<ServiceCentersPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/call-expert" element={<CallExpertPage />} />
          <Route path="/enquire" element={<EnquiryPage />} />
          <Route path="/request-quote" element={<RequestQuotePage />} />
          <Route path="/apply" element={<ApplyPage />} />
          <Route path="/music-video" element={<MusicVideoPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/offers" element={<OffersPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;


